var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-system-bar',{attrs:{"app":"","color":"#1f2428"}},[_vm._l((_vm.buttons),function(button,idx){return _c('v-icon',{key:idx,attrs:{"size":"13","color":button.color}},[_vm._v("mdi-circle")])}),_c('v-spacer'),_c('v-flex',{staticClass:"file-title"},[_vm._v("Jackson Dhanyel Santin - Curriculum Vitae")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }